import React, { ReactElement } from 'react';
import { LoginBlock } from '@btdt/design-system';
import Button, { Theme } from '../../../../design-system/components/atoms/button';

export default function ChangePasswordSuccess(): ReactElement {
  const ctas = <Button theme={Theme.ALL_PRIMARY} fullWidth label="Login" href="/accounts/login/" borderRadius={50} />;
  return (
    <div className="accounts-pages__login-block-wrapper">
      <LoginBlock
        title="Password Changed"
        ctas={ctas}
        image="/static/ds/images/btdt-rebrand-login-noblack.png"
        mobileImage="/static/ds/images/btdt-rebrand-login.png"
        content="Your password has been changed. You may go ahead and log in now."
      />
    </div>
  );
}
